export const FETCH_LOGS_REPORT = "FETCH_LOGS_REPORT";
export const FETCH_LOGS_REPORT_SUCCESS = "FETCH_LOGS_REPORT_SUCCESS";
export const FETCH_LOGS_REPORT_FAILED = "FETCH_LOGS_REPORT_FAILED";

export const DOWNLOAD_LOGS_REPORT = "DOWNLOAD_LOGS_REPORT";
export const DOWNLOAD_LOGS_REPORT_SUCCESS =
  "DOWNLOAD_LOGS_REPORT_SUCCESS";
export const DOWNLOAD_LOGS_REPORT_FAILED =
  "DOWNLOAD_LOGS_REPORT_FAILED";
